import { LoadableAfterPaint } from '@confluence/loadable';

export const UnreadIndicator = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-UnreadIndicator" */ '../src/UnreadIndicator.tsx'))
			.UnreadIndicator,
});
